import { InventoryTagDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/inventory/v1/inventory_tag_events_pb';
import {
  InventoryTagStatus,
  TagType,
} from '@rematter/frontend-lib-api-client/grpc/inventory/v1/inventory_tag_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

import { inventoryTagStatusLabels, tagTypeLabels } from '../enumLabels';

type InventoryTagDeletedDetailProps = {
  event: InventoryTagDeletedEvent;
};

const getStatusLabel = (status: InventoryTagStatus) =>
  inventoryTagStatusLabels[status] ?? 'Unknown';

const getTypeLabel = (tagType: TagType) => tagTypeLabels[tagType] ?? 'Unknown';

export const InventoryTagDeletedDetail = ({
  event,
}: InventoryTagDeletedDetailProps) => {
  const tag = event.inventoryTag;

  if (!tag) {
    return (
      <Col className="@InventoryTagDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@InventoryTagDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted Inventory Tag
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={tag.id?.value} />
          <FieldDisplay label="Tag Number" value={tag.tagNumber} />
          <FieldDisplay label="Tag Type" value={getTypeLabel(tag.tagType)} />
          <FieldDisplay label="Status" value={getStatusLabel(tag.status)} />
          <FieldDisplay
            label="Gross Quantity"
            value={String(tag.grossQuantity)}
          />
          <IDField label="Item ID" value={tag.itemId?.value} />
          <IDField label="Facility ID" value={tag.facilityId?.value} />
        </div>
      </Col>
    </Col>
  );
};
